var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 0v20zM0 20V0zM17.68 2.11.89 9.27A.76.76 0 0 0 1 10.7l2.9.94c.91.29 1.91.15 2.71-.38l7.59-5.09a.34.34 0 0 1 .42.53l-5.69 5.54a.92.92 0 0 0 .13 1.44l6.06 4.06a1.53 1.53 0 0 0 2.36-1l2.08-13.17a1.36 1.36 0 0 0-1.88-1.46"
})));
export default SvgTelegram;